import { TypedNode } from "../_Base";
import { NodeContext } from "../../poly/NodeContext";
import { NodeParamsConfig } from "../utils/params/ParamsConfig";
import { ParamsEditableStateController } from "../utils/io/ParamsEditableStateController";
import { Poly } from "../../Poly";
import { CoreType } from "../../../core/Type";
export const ACTOR_NODE_SELF_TRIGGER_CALLBACK = {
  callback: (node) => {
    BaseActorNodeClass.PARAM_CALLBACK_selfTrigger(node);
  }
};
const INPUT_NAME = "input actor behaviors";
const DEFAULT_INPUT_NAMES = [INPUT_NAME, INPUT_NAME, INPUT_NAME, INPUT_NAME];
export const TRIGGER_CONNECTION_NAME = "trigger";
export class TypedActorNode extends TypedNode {
  constructor() {
    super(...arguments);
    this._paramsEditableStatesController = new ParamsEditableStateController(this);
    this._cookWithoutInputsBound = this._cookWithoutInputs.bind(this);
    this.runTrigger = Poly.playerMode() ? this._triggerConnectionForPlayer : this._triggerConnectionForEditor;
  }
  static context() {
    return NodeContext.ACTOR;
  }
  static displayedInputNames() {
    return DEFAULT_INPUT_NAMES;
  }
  initializeBaseNode() {
    this.uiData.setLayoutHorizontal();
    this.addPostDirtyHook("cookWithoutInputsOnDirty", this._cookWithoutInputsBound);
    this.io.inputs.setDependsOnInputs(false);
    this.io.connections.initInputs();
    this.io.connection_points.spare_params.initializeNode();
    this._paramsEditableStatesController.initializeNode();
  }
  _cookWithoutInputs() {
    this.cookController.cookMainWithoutInputs();
  }
  cook() {
    this.cookController.endCook();
  }
  receiveTrigger(context) {
  }
  _triggerConnectionForEditor(context, outputIndex = 0) {
    const triggerConnections = this.io.connections.outputConnectionsByOutputIndex(outputIndex);
    if (!triggerConnections) {
      return;
    }
    const dispatcher = this.scene().eventsDispatcher.connectionTriggerDispatcher;
    triggerConnections.forEach((triggerConnection) => {
      dispatcher.dispatchTrigger(triggerConnection);
      const node = triggerConnection.node_dest;
      node.receiveTrigger(context);
    });
  }
  _triggerConnectionForPlayer(context, outputIndex = 0) {
    const triggerConnections = this.io.connections.outputConnectionsByOutputIndex(outputIndex);
    if (!triggerConnections) {
      return;
    }
    triggerConnections.forEach((triggerConnection) => {
      const node = triggerConnection.node_dest;
      node.receiveTrigger(context);
    });
  }
  outputValue(context, outputName = "") {
    return void 0;
  }
  _inputValueFromParam(param, context) {
    const inputIndex = this.io.inputs.getInputIndex(param.name());
    const connection = this.io.connections.inputConnection(inputIndex);
    if (connection) {
      const inputNode = connection.node_src;
      const output_connection_point = inputNode.io.outputs.namedOutputConnectionPoints()[connection.output_index];
      if (output_connection_point) {
        const outputName = output_connection_point.name();
        return inputNode.outputValue(context, outputName);
      }
    }
    return param.value;
  }
  _inputValue(inputNameOrIndex, context) {
    const inputIndex = CoreType.isNumber(inputNameOrIndex) ? inputNameOrIndex : this.io.inputs.getInputIndex(inputNameOrIndex);
    const connection = this.io.connections.inputConnection(inputIndex);
    if (connection) {
      const inputNode = connection.node_src;
      const output_connection_point = inputNode.io.outputs.namedOutputConnectionPoints()[connection.output_index];
      if (output_connection_point) {
        const outputName = output_connection_point.name();
        return inputNode.outputValue(context, outputName);
      }
    } else {
      if (CoreType.isString(inputNameOrIndex) && this.params.has(inputNameOrIndex)) {
        return this.params.get(inputNameOrIndex).value;
      }
    }
  }
  static PARAM_CALLBACK_selfTrigger(node) {
    node.scene().actorsManager.manualTriggerController.setNodeToReceiveTrigger(node);
  }
}
export class BaseActorNodeClass extends TypedActorNode {
}
class ParamlessActorParamsConfig extends NodeParamsConfig {
}
const ParamsConfig = new ParamlessActorParamsConfig();
export class ParamlessTypedActorNode extends TypedActorNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
}
